<template>
  <div>
    <el-container class="layoutContainer">
      <el-aside :class="{ elAside: isCollapse }" width="250px">
        <el-menu
          :collapse="isCollapse"
          router
          :default-active="$route.path"
          class="el-menu-vertical-demo"
          background-color="#002033"
          text-color="#fff"
          active-text-color="#ffd04b"
          :unique-opened="true"
        >
          <!-- 可拓展子路由的首页 -->
          <el-menu-item index="/home" v-if="dynamicRoute.home">
            <i class="el-icon-menu"></i>
            <span slot="title">首页可嵌套子集路由表</span>
          </el-menu-item>

          <!-- 工作台 -->
          <el-menu-item index="/workplace" v-if="dynamicRoute.workPlate">
            <i class="el-icon-menu"></i>
            <span slot="title">工作台</span>
          </el-menu-item>

          <!-- 保研信息和工具 -->
          <el-submenu index="/location" v-if="dynamicRoute.data">
            <template slot="title">
              <i class="el-icon-search"></i>
              <span>保研信息和工具</span>
            </template>
            <el-menu-item-group>
              <el-menu-item
                index="/location/index"
                v-if="permissionStr.indexOf('DATA_BAOYAN_LOCATION') > -1"
              >
                统一保研院校定位程序
                <el-tag type="danger" style="margin-left: 6px" size="mini"
                  >BETA</el-tag
                >
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <!-- 百事通 -->
          <el-submenu index="/help" v-if="dynamicRoute.help">
            <template slot="title">
              <i class="el-icon-user-solid"></i>
              <span>百事通</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/help/helpIndex">
                <template>
                  <i class="el-icon-s-management"></i>
                  <span>百事通</span>
                </template>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <!-- 教研 -->
          <el-submenu index="/research" v-if="dynamicRoute.research">
            <template slot="title">
              <i class="el-icon-user-solid"></i>
              <span>教研</span>
            </template>
            <el-menu-item-group>
              <el-menu-item
                index="/research/require"
                v-if="
                  permissionStr.indexOf('T_MATCH_PROCESS') > -1 ||
                  permissionStr.indexOf('T_MATCH_FINISHED') > -1
                "
              >
                <i class="el-icon-document"></i>
                <span slot="title">匹配</span>
              </el-menu-item>
              <el-menu-item
                index="/research/train"
                v-if="permissionStr.indexOf('T_TRAIN_MANAGE') > -1"
              >
                <i class="el-icon-document"></i>
                <span slot="title">培训</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>

          <!-- 资料库 -->
          <el-submenu index="/dataBase" v-if="dynamicRoute.dataBase">
            <template slot="title">
              <i class="el-icon-user-solid"></i>
              <span>资料库</span>
            </template>
            <!-- AI_EXAM_QUESTIONS -->
            <el-menu-item-group>
              <!-- AI智能解答 -->
              <el-menu-item
                index="/dataBase/smartAnswer"
                v-if="permissionStr.indexOf('AI_EXAM_QUESTIONS') > -1"
              >
                <i class="el-icon-document"></i>
                后保老师
              </el-menu-item>
              <!-- 真题库管理 -->
              <el-menu-item
                index="/dataBase/index"
                v-if="
                  permissionStr.indexOf('T_EXAM_QUESTIONS_MANAGE_RETRIEVE') > -1
                "
              >
                <i class="el-icon-document"></i>
                真题库管理
              </el-menu-item>
              <!-- 院校字典 -->
              <el-menu-item
                index="/university/index"
                v-if="permissionStr.indexOf('TOOL_UNIVERSITY_LIB') > -1"
              >
                <i class="el-icon-document"></i>
                院校字典
              </el-menu-item>
              <!-- 推免信息 -->
              <el-menu-item
                index="/Information/index"
                v-if="permissionStr.indexOf('T_CONSUMER_ARTICAL_LIST') > -1"
              >
                <i class="el-icon-document"></i>
                推免信息
              </el-menu-item>
              <!--  院校保研政策 -->
              <el-menu-item
                index="/statistic/academy"
                v-if="permissionStr.indexOf('YXBYZC') > -1"
              >
                <i class="el-icon-document"></i>
                院校保研政策
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>

          <!-- 工单 -->
          <!-- <el-submenu index="/ticket" v-if="dynamicRoute.ticket">
            <template slot="title">
              <i class="el-icon-document"></i>
              <span>工单</span>
            </template>
            <el-menu-item-group>
              <el-menu-item
                index="/ticket/myTicket"
                v-if="permissionStr.indexOf('T_WORKORDER_MY') > -1"
              >
                <i class="el-icon-document"></i>
                <span slot="title">我的工单</span>
              </el-menu-item>
              <el-menu-item
                index="/ticket/manage"
                v-if="permissionStr.indexOf('T_WORKORDER_MA') > -1"
              >
                <i class="el-icon-document"></i>
                <span slot="title">工单管理</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu> -->

          <!-- 学员服务 -->
          <el-submenu index="/studentServer" v-if="dynamicRoute.studentServer">
            <template slot="title">
              <i class="el-icon-user-solid"></i>
              <span>学员服务</span>
            </template>
            <el-menu-item-group>
              <el-menu-item
                index="/studentServer/deliveryList"
                v-if="permissionStr.indexOf('T_CONSUMER_DELIVERY_LIST') > -1"
              >
                <template>
                  <i class="el-icon-s-management"></i>
                  <span>学员投递列表</span>
                </template></el-menu-item
              >
              <el-menu-item
                index="/studentServer/studentPannel"
                v-if="permissionStr.indexOf('T_CONSUMER_MY') > -1"
              >
                <template>
                  <i class="el-icon-s-management"></i>
                  <span>推荐发表</span>
                </template>
              </el-menu-item>
              <el-menu-item
                index="/studentServer/studentAssign"
                v-if="permissionStr.indexOf('T_CONSUMER_ALLOCATE') > -1"
              >
                <template>
                  <i class="el-icon-message-solid"></i>
                  <span>学员分配</span>
                </template>
              </el-menu-item>
              <el-menu-item
                index="/studentServer/allocateSettings"
                v-if="permissionStr.indexOf('T_AUTO_ALLOCATE_SETTINGS') > -1"
              >
                <template>
                  <i class="el-icon-message-solid"></i>
                  <span>自动化分配设置</span>
                </template>
              </el-menu-item>
              <el-menu-item
                index="/studentServer/allocateLogs"
                v-if="permissionStr.indexOf('T_AUTO_ALLOCATE_SETTINGS') > -1"
              >
                <template>
                  <i class="el-icon-message-solid"></i>
                  <span>自动分配日志</span>
                </template>
              </el-menu-item>
              <el-menu-item
                index="/studentServer/index"
                v-if="permissionStr.indexOf('pannel') > -1"
              >
                <template>
                  <i class="el-icon-location"></i>
                  <span>全课程排课</span>
                </template>
              </el-menu-item>
              <el-menu-item
                index="/studentServer/studentCoach"
                v-if="permissionStr.indexOf('T_CONSUMER_SERVICE') > -1"
              >
                <template>
                  <i class="el-icon-s-order"></i>
                  <span>辅导服务</span>
                </template>
              </el-menu-item>

              <el-menu-item
                index="/studentServer/myStudent"
                v-if="permissionStr.indexOf('T_CONSUMER_MY') > -1"
              >
                <template>
                  <i class="el-icon-s-finance"></i>
                  <span>我的学员</span>
                </template>
              </el-menu-item>
              <el-menu-item
                index="/studentServer/studentManage"
                v-if="permissionStr.indexOf('T_CONSUMER_FREEZE_MANAGE') > -1"
              >
                <template>
                  <i class="el-icon-s-order"></i>
                  <span>冻结学员管理</span>
                </template>
              </el-menu-item>
              <el-menu-item
                index="/studentServer/freezeStudent"
                v-if="permissionStr.indexOf('T_CONSUMER_MY') > -1"
              >
                <template>
                  <i class="el-icon-s-order"></i>
                  <span>我冻结的学员</span>
                </template>
              </el-menu-item>
              <el-menu-item
                index="/studentServer/serverHistory"
                v-if="permissionStr.indexOf('T_CONSUMER_HISTORY') > -1"
              >
                <template>
                  <i class="el-icon-s-order"></i>
                  <span>服务历史</span>
                </template>
              </el-menu-item>
              <el-menu-item
                index="/studentServer/xingHuo"
                v-if="permissionStr.indexOf('T_XINGHUO_REPLY_old') > -1"
              >
                <template>
                  <i class="el-icon-s-promotion"></i>
                  <span>星火回访</span>
                </template>
              </el-menu-item>
              <el-menu-item
                index="/studentServer/demand"
                v-if="permissionStr.indexOf('T_MATCH_MY_LAUNCH') > -1"
              >
                <template>
                  <i class="el-icon-s-promotion"></i>
                  <span>我发的匹配</span>
                </template>
              </el-menu-item>
              <el-menu-item
                index="/studentServer/satisfactionTabs"
                v-if="
                  permissionStr.indexOf('T_CONSUMER_SATISFACTION_RESULT') > -1
                "
              >
                <template>
                  <i class="el-icon-s-promotion"></i>
                  <span>满意度</span>
                </template>
              </el-menu-item>
              <el-menu-item
                index="/studentServer/studentDirection"
                v-if="permissionStr.indexOf('T_CONSUMER_WHEREABOUTS') > -1"
              >
                <template>
                  <i class="el-icon-s-promotion"></i>
                  <span>去向</span>
                </template>
              </el-menu-item>
              <el-menu-item
                index="/studentServer/studentYouYing"
                v-if="
                  permissionStr.indexOf('T_STATISTICS_SUMMER_CAMP_ELITE') > -1
                "
              >
                <template>
                  <i class="el-icon-medal-1"></i>
                  <span>学员优营</span>
                </template>
              </el-menu-item>
              <el-menu-item
                index="/studentServer/studentSchedule"
                v-if="permissionStr.indexOf('CHECK_DOC_URL_VIEW') > -1"
              >
                <template>
                  <i class="el-icon-s-custom"></i>
                  <span>学员进度</span>
                </template>
              </el-menu-item>
              <el-menu-item
                index="/studentServer/classHourStatistics"
                v-if="permissionStr.indexOf('T_CONSUMER_CLASS_HOUR_QUERY') > -1"
              >
                <template>
                  <i class="el-icon-s-order"></i>
                  <span>课时统计</span>
                </template>
              </el-menu-item>
              <el-menu-item
                index="/studentServer/consumerStatistics"
                v-if="permissionStr.indexOf('T_CONSUMER_BOARD') > -1"
              >
                <template>
                  <i class="el-icon-s-order"></i>
                  <span>学员看板</span>
                </template>
              </el-menu-item>

              <el-menu-item
                index="/studentServer/refundedStudents"
                v-if="
                  permissionStr.indexOf('T_FINANCE_SEARCH_REFUND_EXPORT') > -1
                "
              >
                <template>
                  <i class="el-icon-s-order"></i>
                  <span>退费学员列表</span>
                </template>
              </el-menu-item>
              <el-menu-item
                index="/studentServer/studentsclass"
                v-if="permissionStr.indexOf('RESERVATION_CLASS') > -1"
              >
                <template>
                  <i class="el-icon-s-order"></i>
                  <span>预约上课</span>
                </template>
              </el-menu-item>
              <el-menu-item
                index="/studentServer/appointmentDetails"
                v-if="permissionStr.indexOf('RESERVATION_RECORD') > -1"
              >
                <template>
                  <i class="el-icon-s-order"></i>
                  <span>预约明细</span>
                </template>
              </el-menu-item>
              <el-menu-item
                index="/studentServer/classschedule"
                v-if="permissionStr.indexOf('CONSUMER_CALENDAR') > -1"
              >
                <template>
                  <i class="el-icon-s-order"></i>
                  <span>学员上课日历</span>
                </template>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <!-- 辅导服务 -->
          <el-submenu index="/coachServer" v-if="dynamicRoute.coachServer">
            <template slot="title">
              <i
                class="iconfont icon-zixun"
                style="margin-right: 8px; margin-left: 3px"
              ></i>
              <span>辅导服务</span>
            </template>
            <el-menu-item index="/coachServer/index">
              <template>
                <i
                  class="iconfont icon-zixun"
                  style="margin-right: 8px; margin-left: 3px"
                ></i>
                <span>辅导服务</span>
              </template>
            </el-menu-item>
            <el-menu-item index="/coachServer/index">
              <template>
                <i
                  class="iconfont icon-zixun"
                  style="margin-right: 8px; margin-left: 3px"
                ></i>
                <span>跟进</span>
              </template>
            </el-menu-item>
          </el-submenu>
          <!-- 财务管理 -->
          <el-submenu index="/statistic" v-if="dynamicRoute.statistic">
            <template slot="title">
              <i class="el-icon-location"></i>
              <span>财务管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item
                index="/statistic/index"
                v-if="permissionStr.indexOf('T_STATISTICS_UNIVERSITY_old') > -1"
              >
                <template>
                  <i class="el-icon-location"></i>
                  <span>保研高校</span>
                </template>
              </el-menu-item>
              <el-menu-item
                v-if="permissionStr.indexOf('T_STATISTICS_HANDOVER_old') > -1"
                index="/statistic/handover"
              >
                <template>
                  <i class="el-icon-location"></i>
                  <span>交接</span>
                </template>
              </el-menu-item>
              <el-menu-item
                v-if="
                  permissionStr.indexOf('T_STATISTICS_SERVICE_LOAD_old') > -1
                "
                index="/statistic/serverLoad"
              >
                <template>
                  <i class="el-icon-location"></i>
                  <span>服务负载</span>
                </template>
              </el-menu-item>
              <el-menu-item
                v-if="permissionStr.indexOf('T_STATISTICS_COUNSELOR_old') > -1"
                index="/statistic/counselor"
              >
                <template>
                  <i class="el-icon-location"></i>
                  <span>咨询师</span>
                </template>
              </el-menu-item>
              <el-menu-item
                v-if="permissionStr.indexOf('T_STATISTICS_CONSUMER_old') > -1"
                index="/statistic/consumer"
              >
                <template>
                  <i class="el-icon-location"></i>
                  <span>学员</span>
                </template>
              </el-menu-item>
              <el-menu-item
                v-if="permissionStr.indexOf('T_STATISTICS_PRODUCT_old') > -1"
                index="/statistic/product"
              >
                <template>
                  <i class="el-icon-location"></i>
                  <span>产品</span>
                </template>
              </el-menu-item>
              <el-menu-item
                v-if="
                  permissionStr.indexOf('T_STATISTICS_PRODUCT_CONVERT') > -1
                "
                index="/statistic/productConvert"
              >
                <template>
                  <i class="el-icon-location"></i>
                  <span>产品转化</span>
                </template>
              </el-menu-item>
              <el-menu-item
                v-if="
                  permissionStr.indexOf('T_STATISTICS_CONSUMER_CONVERT_old') >
                  -1
                "
                index="/statistic/consumerConvert"
              >
                <template>
                  <i class="el-icon-location"></i>
                  <span>学员转化</span>
                </template>
              </el-menu-item>
              <el-menu-item
                v-if="permissionStr.indexOf('T_STATISTICS_CONDITION_old') > -1"
                index="/statistic/condition"
              >
                <template>
                  <i class="el-icon-location"></i>
                  <span>特定条件</span>
                </template>
              </el-menu-item>
              <el-menu-item
                v-if="
                  permissionStr.indexOf('T_STATISTICS_CONSUMER_PAYMENT_old') >
                  -1
                "
                index="/statistic/consumerPayment"
              >
                <template>
                  <i class="el-icon-location"></i>
                  <span>学员付款</span>
                </template>
              </el-menu-item>
              <el-menu-item
                index="/statistic/specifiedConditions"
                v-if="
                  permissionStr.indexOf(
                    'T_STATISTICS_SEARCH_CONDITION_EXPORT'
                  ) > -1
                "
              >
                <template>
                  <i class="el-icon-location"></i>
                  <span>特定条件(财务)</span>
                </template>
              </el-menu-item>
              <el-menu-item
                index="/statistic/payment"
                v-if="permissionStr.indexOf('T_STATISTICS_PAYMENT') > -1"
              >
                <template>
                  <i class="el-icon-location"></i>
                  <span>学员付款(财务)</span>
                </template>
              </el-menu-item>
              <el-menu-item
                index="/statistic/consumerRefund"
                v-if="permissionStr.indexOf('T_CONSUMER_REFUND_FINANCE') > -1"
              >
                <template>
                  <i class="el-icon-location"></i>
                  <span>退费列表</span>
                </template>
              </el-menu-item>
              <el-menu-item
                index="/statistic/consumerPayReturn"
                v-if="
                  permissionStr.indexOf('T_CONSUMER_PAY_RETURN_FINANCE') > -1
                "
              >
                <template>
                  <i class="el-icon-location"></i>
                  <span>返还列表</span>
                </template>
              </el-menu-item>
              <el-menu-item
                index="/statistic/consumerPerformanceCommission/splitPerformance"
                v-if="permissionStr.indexOf('T_SALE_PERFORMANCE_SPLIT') > -1"
              >
                <template slot="title">
                  <i class="el-icon-s-data"></i>
                  <span>业绩拆分</span>
                </template>
              </el-menu-item>
              <el-menu-item
                index="/statistic/consumerPerformanceCommission/performanceCommission"
                v-if="permissionStr.indexOf('T_SALE_COMMISSION_CALCULATE') > -1"
              >
                <template slot="title">
                  <i class="el-icon-s-data"></i>
                  <span>计算提成</span>
                </template>
              </el-menu-item>
              <el-menu-item
                index="/statistic/channelAgentFee"
                v-if="
                  permissionStr.indexOf('T_CONSUMER_COSTOUT_DAILIFEI') > -1 ||
                  permissionStr.indexOf('T_CONSUMER_COSTOUT_QUDAOFEI') > -1
                "
              >
                <template>
                  <i class="el-icon-location"></i>
                  <span>渠道代理费用</span>
                </template>
              </el-menu-item>
              <el-menu-item
                index="/statistic/consumerCostOut"
                v-if="
                  permissionStr.indexOf('T_FINANCE_CONSUMER_COSTOUT_MANAGE') >
                  -1
                "
              >
                <template>
                  <i class="el-icon-location"></i>
                  <span>学员成本办结管理</span>
                </template>
              </el-menu-item>

              <el-menu-item
                index="/statistic/partner"
                v-if="permissionStr.indexOf('T_FINANCE_PARTNER_MANAGE') > -1"
              >
                <template>
                  <i class="el-icon-document"></i>
                  <span slot="title">合作方管理</span>
                </template>
              </el-menu-item>
              <el-menu-item
                index="/statistic/studentCost"
                v-if="
                  permissionStr.indexOf('T_FINANCE_SEARCH_PERIOD_EXPORT') > -1
                "
              >
                <template>
                  <i class="el-icon-document"></i>
                  <span slot="title">学员成本</span>
                </template>
              </el-menu-item>
              <el-menu-item
                index="/statistic/consumerRealClassHourChange"
                v-if="
                  permissionStr.indexOf(
                    'T_FINANCE_SEARCH_REAL_CLASS_HOUR_CHANGE_RECORD_EXPORT'
                  ) > -1
                "
              >
                <template>
                  <i class="el-icon-document"></i>
                  <span slot="title">学员真实课时变更</span>
                </template>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <!-- 咨询师 -->
          <el-submenu index="/counselor" v-if="dynamicRoute.counselor">
            <template slot="title">
              <i class="el-icon-user-solid"></i>
              <span>咨询师</span>
            </template>
            <el-menu-item-group>
              <el-menu-item
                index="/counselor/master"
                v-if="permissionStr.indexOf('T_COUNSELOR_LIB') > -1"
              >
                <i class="el-icon-document"></i>
                <span slot="title">硕士</span>
              </el-menu-item>
              <el-menu-item
                index="/counselor/counselorCheck"
                v-if="permissionStr.indexOf('T_COUNSELOR_LIB') > -1"
              >
                <i class="el-icon-document"></i>
                <span slot="title">硕士审核</span>
              </el-menu-item>
              <el-menu-item
                index="/counselor/recommend"
                v-if="permissionStr.indexOf('T_COUNSELOR_LIB') > -1"
              >
                <i class="el-icon-document"></i>
                <span slot="title">硕士推荐</span>
              </el-menu-item>
              <el-menu-item
                index="/counselor/doctor"
                v-if="permissionStr.indexOf('T_COUNSELOR_LIB') > -1"
              >
                <i class="el-icon-document"></i>
                <span slot="title">博士</span>
              </el-menu-item>
              <el-menu-item
                index="/counselor/doctorCheck"
                v-if="permissionStr.indexOf('T_COUNSELOR_LIB') > -1"
              >
                <i class="el-icon-document"></i>
                <span slot="title">博士审核</span>
              </el-menu-item>
              <el-menu-item
                index="/counselor/incomeRecord"
                v-if="permissionStr.indexOf('T_COUNSELOR_LIB') > -1"
              >
                <i class="el-icon-document"></i>
                <span slot="title">入账记录</span>
              </el-menu-item>
              <el-menu-item
                index="/counselor/outCostRecord"
                v-if="permissionStr.indexOf('T_COUNSELOR_LIB') > -1"
              >
                <i class="el-icon-document"></i>
                <span slot="title">提现记录</span>
              </el-menu-item>
              <el-menu-item
                index="/counselor/deductionRecords"
                v-if="permissionStr.indexOf('T_COUNSELOR_LIB') > -1"
              >
                <i class="el-icon-document"></i>
                <span slot="title">扣款记录</span>
              </el-menu-item>
              <el-menu-item
                index="/salary/satisfactionSalary"
                v-if="permissionStr.indexOf('T_COUNSELOR_LIB') > -1"
              >
                <i class="el-icon-document"></i>
                <span slot="title">实习身份</span>
              </el-menu-item>
              <el-menu-item
                index="/salary/salaryCheckList"
                v-if="permissionStr.indexOf('T_COUNSELOR_LIB') > -1"
              >
                <i class="el-icon-document"></i>
                <span slot="title">入账审核中</span>
              </el-menu-item>
              <el-menu-item
                index="/salary/salaryFirst"
                v-if="permissionStr.indexOf('T_COUNSELOR_CHECK1') > -1"
              >
                <i class="el-icon-document"></i>
                <span slot="title">入账一审</span>
              </el-menu-item>
              <el-menu-item
                index="/salary/salarySecond"
                v-if="permissionStr.indexOf('T_COUNSELOR_CHECK2') > -1"
              >
                <i class="el-icon-document"></i>
                <span slot="title">入账二审</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <!-- 薪酬管理 -->
          <el-submenu index="/salary" v-if="dynamicRoute.salary">
            <template slot="title">
              <i class="el-icon-user-solid"></i>
              <span>薪酬管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item
                index="/salary/counselorBalance"
                v-if="permissionStr.indexOf('T_FINANCE_ALLOW_UNALLOW') > -1"
              >
                <i class="el-icon-document"></i>
                <span slot="title">薪酬标准</span>
              </el-menu-item>
              <el-menu-item
                index="/salary/salarySubmit"
                v-if="permissionStr.indexOf('T_FINANCE_SUBMIT') > -1"
              >
                <i class="el-icon-document"></i>
                <span slot="title">薪酬提交</span>
              </el-menu-item>
              <el-menu-item
                index="/salary/salaryCheck"
                v-if="permissionStr.indexOf('T_FINANCE_CHECK') > -1"
              >
                <i class="el-icon-document"></i>
                <span slot="title">由我审核</span>
              </el-menu-item>
              <el-menu-item
                index="/salary/salaryType"
                v-if="permissionStr.indexOf('T_FINANCE_ALLOW_UNALLOW') > -1"
              >
                <i class="el-icon-document"></i>
                <span slot="title">审核结果列表</span>
              </el-menu-item>
              <el-menu-item
                index="/salary/salaryResolution"
                v-if="permissionStr.indexOf('T_FINANCE_SPLIT') > -1"
              >
                <i class="el-icon-document"></i>
                <span slot="title">拆分薪酬</span>
              </el-menu-item>
              <el-menu-item
                index="/salary/monthSalary"
                v-if="permissionStr.indexOf('T_FINANCE_CURRENT_MONTH') > -1"
              >
                <i class="el-icon-document"></i>
                <span slot="title">当月薪酬</span>
              </el-menu-item>
              <el-menu-item
                index="/salary/nextMonthSalary"
                v-if="permissionStr.indexOf('T_FINANCE_NEXT_MONTH') > -1"
              >
                <i class="el-icon-document"></i>
                <span slot="title">下月薪酬</span>
              </el-menu-item>
              <el-menu-item
                index="/salary/historySalary"
                v-if="permissionStr.indexOf('T_FINANCE_HISTORY') > -1"
              >
                <i class="el-icon-document"></i>
                <span slot="title">发放历史</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <!-- 系统 -->
          <el-submenu index="/system" v-if="dynamicRoute.system">
            <template slot="title">
              <i class="el-icon-user-solid"></i>
              <span>系统管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item
                index="/system/accountManage"
                v-if="permissionStr.indexOf('T_SETTINGS_ACCOUNT_MANAGE') > -1"
              >
                <i class="el-icon-document"></i>
                <span slot="title">账户管理</span>
              </el-menu-item>
              <el-menu-item
                index="/system/roleManagement"
                v-if="permissionStr.indexOf('T_CONSUMER_ROLE_MANAGE') > -1"
              >
                <i class="el-icon-document"></i>
                <span slot="title">学员角色管理</span>
              </el-menu-item>
              <el-menu-item
                index="/system/studentAccount"
                v-if="permissionStr.indexOf('T_CONSUMER_ACCOUNT_MANAGE') > -1"
              >
                <i class="el-icon-document"></i>
                <span slot="title">学员账号</span>
              </el-menu-item>
              <el-menu-item
                index="/system/semesterManagement"
                v-if="
                  permissionStr.indexOf('T_CONSUMER_SEMESTER_DICT_MANAGE') > -1
                "
              >
                <i class="el-icon-document"></i>
                <span slot="title">学期管理</span>
              </el-menu-item>
              <el-menu-item
                index="/system/competitionManagement"
                v-if="
                  permissionStr.indexOf('T_CONSUMER_CONTEST_DICT_MANAGE') > -1
                "
              >
                <i class="el-icon-document"></i>
                <span slot="title">竞赛管理</span>
              </el-menu-item>
              <el-menu-item
                index="/system/courseManagement"
                v-if="
                  permissionStr.indexOf('T_CONSUMER_COURSE_DICT_MANAGE') > -1
                "
              >
                <i class="el-icon-document"></i>
                <span slot="title">课程类别管理</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <!-- 微官网 -->
          <el-submenu index="/officialWebSite" v-if="dynamicRoute.website">
            <template slot="title">
              <i class="el-icon-user-solid"></i>
              <span>微官网管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item
                index="/officialWebSite/courseManagement"
                v-if="permissionStr.indexOf('T_MINIHOME_MANAGE') > -1"
              >
                <i class="el-icon-document"></i>
                <span slot="title">课程管理</span>
              </el-menu-item>
              <el-menu-item
                index="/officialWebSite/courseEntry"
                v-if="permissionStr.indexOf('T_MINIHOME_MANAGE') > -1"
              >
                <i class="el-icon-document"></i>
                <span slot="title">课题管理</span>
              </el-menu-item>
              <el-menu-item
                index="/officialWebSite/subjectManage"
                v-if="permissionStr.indexOf('T_MINIHOME_MANAGE') > -1"
              >
                <i class="el-icon-document"></i>
                <span slot="title">学科大类管理</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <!-- 工具 -->
          <el-submenu index="/toolsPage" v-if="dynamicRoute.tool">
            <template slot="title">
              <i class="el-icon-user-solid"></i>
              <span>工具</span>
            </template>
            <el-menu-item-group>
              <el-menu-item
                index="/toolsPage/toolsPage"
                v-if="permissionStr.indexOf('T_TOOL_IDCARD_CHECK') > -1"
              >
                <i class="el-icon-document"></i>
                <span slot="title">身份证核验</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <!-- 数据审核 -->
          <el-submenu index="/topicsPage" v-if="dynamicRoute.collect">
            <template slot="title">
              <i class="el-icon-user-solid"></i>
              <span>数据审核</span>
            </template>
            <el-menu-item-group>
              <el-menu-item
                index="/topicsPage"
                v-if="permissionStr.indexOf('T_COLLECT_TOPIC_CHECK') > -1"
              >
                <i class="el-icon-document"></i>
                <span slot="title">真题审核</span>
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <!-- 试卷管理 -->
          <el-submenu index="/exam" v-if="dynamicRoute.collect">
            <template slot="title">
              <i class="el-icon-user-solid"></i>
              <span>试卷管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item
                index="/exam"
                v-if="permissionStr.indexOf('T_EXAM_MANAGE') > -1"
              >
                <i class="el-icon-document"></i>
                <!--  slot="title" -->
                <span>试卷</span>
                <!-- <el-tag type="danger" effect="plain" size="mini" style="margin-left: 5px">
                  内测版
                </el-tag> -->
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-container>
        <el-header class="layoutContainer-header">
          <div class="layoutContainer-header-left">
            <i
              @click="isCollapse = !isCollapse"
              :class="{
                'el-icon-s-fold': isCollapse,
                'el-icon-s-unfold': !isCollapse,
              }"
              style="cursor: pointer"
            ></i>
            <h6>道可道也教学与教务服务平台</h6>
          </div>

          <div class="layoutContainer-header-right">
            <el-tooltip placement="bottom" effect="dark">
              <div slot="content" style="max-width: 280px; line-height: 1.6">
                本系统将在未来下线，请使用新 EAS 平台，未来 AI 功能将在 EAS
                中提供。
              </div>
              <a
                class="try-new-crm"
                :href="easLoginUrl"
                target="_blank"
                rel="noopener noreferrer"
                >体验新EAS</a
              >
            </el-tooltip>
            <span
              class="layoutContainer-header-right-span"
              @click="toLink('https://teach.houbaoyan.cn/#/login')"
            >
              道可道也咨询师平台
              <i class="el-icon-top-right"></i>
            </span>
            <span
              class="layoutContainer-header-right-consumer"
              @click="toLink('https://consumer.houbaoyan.cn/#/login')"
            >
              道可道也学员平台
              <i class="el-icon-top-right"></i>
            </span>
            <el-dropdown @command="handleClick">
              <span class="el-dropdown-link">
                {{ roleNickWhoName }}
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="1">实名认证</el-dropdown-item>
                <el-dropdown-item command="2">修改密码</el-dropdown-item>
                <el-dropdown-item command="3">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-header>

        <el-main class="el-main">
          <!-- <el-breadcrumb class="breadCrumb" separator="/">
            <el-breadcrumb-item v-for="(item) in breadList" :key="item.path" :to="item.path ">{{item.meta.title}}</el-breadcrumb-item>
          </el-breadcrumb>-->
          <!-- <div style="padding-bottom: 10px">
            <el-alert title="" type="warning" :closable="false" center>
              <template slot="title">
                <p style="display: flex; align-items: center">
                  各位同事，系统资源属于公司资源，不允许外借，使用过程中建议定期换密码，系统异常使用后台可以实时监控，请注意保密。
                </p>
              </template>
            </el-alert>
          </div> -->

          <el-card
            :class="{
              'data-base-card': isDataBasePage,
              'smart-answer-card': isSmartAnswerPage,
            }"
          >
            <router-view></router-view>

            <div
              v-if="permissionStr.indexOf('AI_EXAM_QUESTIONS') > -1"
              class="iconbox"
              @click="iframeBtn"
              :style="{ top: boxTop + 'px', right: boxRight + 'px' }"
              @mousedown="boxDragStart"
            >
              <img
                src="https://hbyoss.houbaoyan.cn/static/img/22EBE93B-1EE6-4D8C-8D57-0CFD7FB6C14C.gif"
                class="avatar"
              />
              <p>后</p>
              <p>保</p>
              <p>老</p>
              <p>师</p>
            </div>
          </el-card>
        </el-main>
      </el-container>
    </el-container>

    <!-- 弹窗 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <!-- form表单 -->
      <el-form
        ref="mobileRef"
        :rules="formRules"
        :model="mobileForm"
        label-width="80px"
      >
        <el-form-item v-if="disabledObj.isshow" label="手机号" prop="mobile">
          <el-input
            :disabled="disabledObj.mobileDisabled"
            v-model="mobileForm.mobile"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="mobileForm.whoName" label="姓名">
          <el-input
            :disabled="disabledObj.mobileDisabled"
            v-model="mobileForm.whoName"
            placeholder="姓名"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="disabledObj.emailIsshow" label="邮箱" prop="email">
          <el-input v-model="mobileForm.email" placeholder="邮箱"></el-input>
        </el-form-item>
        <el-form-item
          label="旧密码"
          v-if="disabledObj.passwordIsshow"
          prop="oldPassword"
        >
          <el-input
            v-model="mobileForm.oldPassword"
            placeholder="请输入旧密码"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="newPassword"
          label="新密码"
          v-if="disabledObj.passwordIsshow"
        >
          <el-input
            v-model="mobileForm.newPassword"
            placeholder="请输入新密码，最低12位，必须包含大写字母、小写字母、数字三种。"
          ></el-input>
        </el-form-item>
        <el-form-item label="【必读】" v-if="disabledObj.isshow">
          <span>为了验证邮箱真实性，实名成功后，会发送新密码到邮箱中。</span>
        </el-form-item>
      </el-form>
      <!-- 退出提示 -->
      <div v-if="disabledObj.excitIsshow">
        <span>你确定退出教务系统?</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelBtn">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <!-- iframe -->
    <div
      :style="{ top: top + 'px', right: right + 'px' }"
      class="iframeBox"
      v-show="ifrDialogVisible"
      @mousedown="dragStart"
    >
      <div class="iframe_header">
        <div class="color_header"></div>
        <div class="iframe_title">
          <span>后保老师</span>
          <svg
            t="1772773378658"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2875"
            width="20"
            height="20"
            style="cursor: pointer"
            @click="ifrDialogVisible = false"
          >
            <path
              d="M837.12 801.28l-289.28-289.28 289.28-289.28c10.24-10.24 10.24-25.6 0-35.84-10.24-10.24-25.6-10.24-35.84 0l-289.28 289.28-289.28-289.28c-10.24-10.24-25.6-10.24-35.84 0-10.24 10.24-10.24 25.6 0 35.84l289.28 289.28-289.28 289.28c-10.24 10.24-10.24 25.6 0 35.84 10.24 10.24 25.6 10.24 35.84 0l289.28-289.28 289.28 289.28c10.24 10.24 25.6 10.24 35.84 0 10.24-10.24 10.24-25.6 0-35.84z"
              p-id="2876"
            ></path>
          </svg>
        </div>
      </div>
      <div class="iframe_body">
        <iframe
          id="vue_iframe"
          :src="iframeUrl"
          ref="child"
          name="example"
          allowfullscreen="true"
          webkitallowfullscreen="true"
          mozallowfullscreen="true"
        >
        </iframe>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import {
  obtainAuthenticationInfoByMobile,
  changePassword,
  authenticationWhoName,
  userInfo,
} from "@/config/http/user";
import { EAS_LOGIN_URL } from "@/utils/newSystem";
export default {
  name: "LayoutViews",
  data() {
    const validatePass1 = (rule, value, callback) => {
      const emailRegExp = /\w+([-+.]\w+)*@houbaoyan.com/;
      if (emailRegExp.test(value)) {
        callback();
      } else {
        callback(
          new Error('您输入的邮箱不符合规则,必选要以"@houbaoyan.com"结尾')
        );
      }
    };
    const validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("新密码不能为空"));
      } else if (value === this.mobileForm.oldPassword) {
        callback(new Error("新密码与旧密码不能相同!"));
      } else {
        callback();
      }
    };
    return {
      // iframe
      ifrDialogVisible: false,
      iframeUrl: "",
      token: "",
      // iframe
      top: 195, // 初始top位置
      right: 110, // 初始left位置
      isDragging: false, // 是否正在拖拽
      startX: 0, // 鼠标初始X坐标
      startY: 0, // 鼠标初始Y坐标
      offsetX: 0, // 鼠标相对于元素左上角的X偏移量
      offsetY: 0, // 鼠标相对于元素左上角的Y偏移量
      // 后保老师
      startXwidth: {
        sWidth: 0,
        sHeight: 0,
      },
      boxTop: 50,
      boxRight: 30,
      boxIsDragging: false, // 是否正在拖拽
      boxStartX: 0, // 鼠标初始X坐标
      boxStartY: 0, // 鼠标初始Y坐标
      boxOffsetX: 0, // 鼠标相对于元素左上角的X偏移量
      boxOffsetY: 0, // 鼠标相对于元素左上角的Y偏移量

      // 是否是真题库管理页面
      isDataBasePage: false,
      isSmartAnswerPage: false,
      // 状态
      status: true,
      // 权限路由
      dynamicRoute: {
        // 工作台
        workPlate: false,
        // 教研
        research: false,
        dataBase: false,
        // 学员服务
        studentServer: false,
        // 财务管理
        statistic: false,
        // 辅导服务
        coachServer: false,
        // 保研信息和工具
        data: false,
      },
      // 权限列表
      permissionStr: "",
      // 折叠按钮
      isCollapse: false,
      // 手机号
      mobileForm: {
        mobile: "",
        whoName: "",
        email: "",
        oldPassword: "",
        newPassword: "",
      },
      // 弹窗标题
      title: "",
      dialogVisible: false,
      // 是否可修改
      disabledObj: {
        // 控制手机号是否显示
        isshow: false,
        // 控制手机号是否可以修改
        mobileDisabled: false,
        // 控制用户名是否可以修改
        whoNameDisabled: false,
        // 控制邮箱是否显示
        emailIsshow: false,
        // 控制密码是否可以显示
        passwordIsshow: false,
        // 控制是否显示退出文字
        excitIsshow: false,
      },
      // 部门-名字-职务
      roleNickWhoName: "",
      // 根据类型判断，用户点击触发的方法
      type: "",
      // 校验
      formRules: {
        mobile: [
          { required: true, message: "手机号为必填！", trigger: "blur" },
        ],
        whoName: [
          { required: true, message: "用户名为必填！", trigger: "blur" },
        ],
        email: [
          { required: true, message: "邮箱为必填！", trigger: "blur" },
          { validator: validatePass1, trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: "新密码为必填！", trigger: "blur" },
          { validator: validatePass2, trigger: "blur" },
        ],
        oldPassword: [
          { required: true, message: "旧密码为必填！", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getUserinfo();
    // 初始化路由状态
    this.checkRoute();

    if (
      process.env.NODE_ENV === "development" ||
      process.env.NODE_ENV === "test"
    ) {
      // this.iframeUrl = "http://10.126.126.99:8900/#/exam-h5questions?token=";
      this.iframeUrl = "http://10.126.126.99:8900/#/exam-questions?token=";
    } else if (process.env.NODE_ENV === "production") {
      this.iframeUrl = "https://advisor.houbaoyan.cn/#/exam-questions?token=";
    }
    // this.iframeUrl = "http://10.126.126.99:8900/#/exam-questions?token=";
    if (localStorage.getItem("token")) {
      this.token = localStorage.getItem("token");
      this.iframeUrl = `${this.iframeUrl}${this.token}`;
    }
  },
  watch: {
    // 监听路由变化
    "$route.path": {
      handler() {
        this.checkRoute();
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState("user", { premission: "premissions" }),
    breadList() {
      // console.log(this.$route, "路由元信息");
      return this.$route.matched;
    },
    // 新版教务系统登录地址（开发 / 生产由 utils/newSystem 区分）
    easLoginUrl() {
      return EAS_LOGIN_URL;
    },
  },
  methods: {
    ...mapMutations("user", { setPermissions: "setPermissions" }),
    handleClick(a) {
      // console.log("a的属性是:", a);
      this.type = a;
      // 实名认证
      if (a === "1") {
        this.dialogVisible = true;
        this.disabledObj.isshow = true;
        this.disabledObj.emailIsshow = false;
        this.disabledObj.passwordIsshow = false;
        this.disabledObj.excitIsshow = false;
        this.title = "实名认证";
        // 修改密码
      } else if (a === "2") {
        this.dialogVisible = true;
        this.disabledObj.isshow = false;
        this.disabledObj.emailIsshow = false;
        this.disabledObj.passwordIsshow = true;
        this.disabledObj.excitIsshow = false;
        this.title = "修改密码";
        // 退出
      } else if (a === "3") {
        this.dialogVisible = true;
        this.disabledObj.isshow = false;
        this.disabledObj.emailIsshow = false;
        this.disabledObj.passwordIsshow = false;
        this.disabledObj.excitIsshow = true;
        this.title = "退出登录";
      }
    },
    handleConfirm() {
      // console.log(this.type, "a");
      // console.log(typeof this.mobileForm.mobile);
      // 实名认证
      if (this.type === "1") {
        this.$refs.mobileRef.validate((valid) => {
          if (valid) {
            obtainAuthenticationInfoByMobile(this.mobileForm).then((res) => {
              console.log(res, "res");
              this.mobileForm.whoName = res.data.data.whoName;
              this.disabledObj.emailIsshow = true;
              this.disabledObj.mobileDisabled = true;
              this.disabledObj.whoNameDisabled = true;
              this.type = "";
              // this.handleConfirm()
            });
          } else {
            this.$message({
              type: "warning",
              message: "手机号为必填",
            });
            return false;
          }
        });

        // 修改密码
      } else if (this.type === "2") {
        this.$refs.mobileRef.validate((valid) => {
          if (valid) {
            changePassword(this.mobileForm).then((res) => {
              this.$notify({
                type: "success",
                message: "修改密码成功！",
              });
              this.dialogVisible = false;
              this.$router.push("/login");
            });
          } else {
            this.$message({
              type: "warning",
              message: "新旧密码不能相同",
            });
            return false;
          }
        });

        // 退出登录
      } else if (this.type === "3") {
        window.localStorage.removeItem("token");
        window.localStorage.removeItem("permissions");
        window.localStorage.removeItem("roleName");
        window.localStorage.removeItem("studentId");
        this.$notify({
          type: "success",
          message: "退出成功!",
        });
        this.dialogVisible = false;
        this.$router.push("/login");

        // 根据手机号获取实名
      } else {
        this.$refs.mobileRef.validate((valid) => {
          if (valid) {
            authenticationWhoName(this.mobileForm).then((res) => {
              this.$notify({
                type: "success",
                message: "实名认证成功！",
              });
              this.dialogVisible = false;
              window.localStorage.removeItem("token");
              window.localStorage.removeItem("premissions");
              window.localStorage.removeItem("roleName");
              window.localStorage.removeItem("studentId");
              this.$router.push("/login");
            });
          } else {
            this.$message({
              type: "warning",
              message: "邮箱为必填",
            });
            return false;
          }
        });
      }
    },
    cancelBtn() {
      this.dialogVisible = false;
      location.reload();
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    async getUserinfo() {
      const res = await userInfo();
      // console.log(res, 'res-获取当前账户的信息')
      const permission = res.data.data.permissions;
      localStorage.setItem("roleName", res.data.data.roleName);
      // console.log(permission, "res-获取当前账户的信息");
      this.permissionStr = permission;
      this.setPermissions(permission);
      this.roleNickWhoName =
        res.data.data.nickName +
        "- " +
        res.data.data.whoName +
        "-" +
        res.data.data.roleName;
      this.setRouter(permission);
    },
    // 和权限列表进行比对
    setRouter(permission) {
      const arr = permission;
      this.dynamicRoute.workPlate = this.checkRouter(
        ["T_ACCOUNT_GENERAL"],
        arr
      );
      this.dynamicRoute.help = this.checkRouter(["T_KNOWER_HOME"], arr);
      this.dynamicRoute.dataBase = this.checkRouter(
        [
          "AI_EXAM_QUESTIONS",
          "T_EXAM_QUESTIONS_MANAGE_RETRIEVE",
          "TOOL_UNIVERSITY_LIB",
          "T_CONSUMER_ARTICAL_LIST",
          "YXBYZC",
        ],
        arr
      );
      this.dynamicRoute.research = this.checkRouter(
        ["T_MATCH_PROCESS", "T_MATCH_FINISHED", "T_TRAIN_MANAGE"],
        arr
      );
      this.dynamicRoute.counselor = this.checkRouter(
        ["T_COUNSELOR_LIB", "T_COUNSELOR_CHECK1", "T_COUNSELOR_CHECK2"],
        arr
      );
      this.dynamicRoute.salary = this.checkRouter(
        [
          "T_FINANCE_SUBMIT",
          "T_FINANCE_CHECK",
          "T_FINANCE_ALLOW_UNALLOW",
          "T_FINANCE_SPLIT",
          "T_FINANCE_CURRENT_MONTH",
          "T_FINANCE_NEXT_MONTH",
          "T_FINANCE_HISTORY",
          "T_FINANCE_INTERNSHIP",
        ],
        arr
      );
      this.dynamicRoute.studentServer = this.checkRouter(
        [
          "T_CONSUMER_ALLOCATE",
          "T_AUTO_ALLOCATE_SETTINGS",
          "T_CONSUMER_SERVICE",
          "T_STATISTICS_SUMMER_CAMP_ELITE",
          "T_XINGHUO_REPLY",
          "T_CONSUMER_MY",
          "T_CONSUMER_DELIVERY_LIST",
          "T_CONSUMER_FREEZE_MANAGE",
          "CHECK_DOC_URL_VIEW",
          "T_CONSUMER_CLASS_HOUR_QUERY",
          "T_CONSUMER_BOARD",
          "T_FINANCE_SEARCH_REFUND_EXPORT",
          "RESERVATION_CLASS",
          "RESERVATION_RECORD",
          "CONSUMER_CALENDAR",
        ],
        arr
      );
      this.dynamicRoute.coachServer = this.checkRouter(["STUDENT_SERVER"], arr);
      this.dynamicRoute.statistic = this.checkRouter(
        [
          "T_STATISTICS_UNIVERSITY",
          "T_STATISTICS_HANDOVER",
          "T_STATISTICS_SERVICE_LOAD",
          "T_STATISTICS_COUNSELOR",
          "T_STATISTICS_CONSUMER",
          "T_STATISTICS_PRODUCT",
          "T_STATISTICS_PRODUCT_CONVERT",
          "T_STATISTICS_CONSUMER_CONVERT",
          "T_STATISTICS_CONDITION",
          "T_STATISTICS_CONSUMER_PAYMENT",
          "T_STATISTICS_SEARCH_CONDITION_EXPORT",
          "T_STATISTICS_PAYMENT",
          "T_CONSUMER_REFUND_FINANCE",
          "T_CONSUMER_PAY_RETURN_FINANCE",
          "T_SALE_PERFORMANCE_SPLIT",
          "T_SALE_COMMISSION_CALCULATE",
          "T_CONSUMER_COSTOUT_DAILIFEI",
          "T_CONSUMER_COSTOUT_QUDAOFEI",
          "T_FINANCE_CONSUMER_COSTOUT_MANAGE",
          "T_FINANCE_PARTNER_MANAGE",
          "T_FINANCE_SEARCH_PERIOD_EXPORT",
          "T_FINANCE_SEARCH_REAL_CLASS_HOUR_CHANGE_RECORD_EXPORT",
        ],
        arr
      );
      this.dynamicRoute.system = this.checkRouter(
        [
          "T_SETTINGS_ACCOUNT_MANAGE",
          "T_CONSUMER_SEMESTER_DICT_MANAGE",
          "T_CONSUMER_COURSE_DICT_MANAGE",
          "T_CONSUMER_CONTEST_DICT_MANAGE",
          "T_CONSUMER_ROLE_MANAGE",
          "T_CONSUMER_ACCOUNT_MANAGE",
        ],
        arr
      );
      this.dynamicRoute.website = this.checkRouter(["T_MINIHOME_MANAGE"], arr);
      // this.dynamicRoute.ticket = this.checkRouter(
      //   ["T_WORKORDER_MY", "T_WORKORDER_MA"],
      //   arr
      // );
      this.dynamicRoute.tool = this.checkRouter(["T_TOOL_IDCARD_CHECK"], arr);
      this.dynamicRoute.collect = this.checkRouter(
        ["T_COLLECT_TOPIC_CHECK"],
        arr
      );
      this.dynamicRoute.data = this.checkRouter(
        [
          "TOOL_UNIVERSITY_LIB",
          "T_CONSUMER_ARTICAL_LIST",
          "DATA_BAOYAN_LOCATION",
          "YXBYZC",
        ],
        arr
      );
    },
    // 控制一级导航栏是否显示
    checkRouter(routerList, permission) {
      for (let i = 0; i < routerList.length; i++) {
        if (permission.indexOf(routerList[i]) > -1) {
          return true;
        }
      }
      return false;
    },
    // 检查当前路由是否是真题库管理页面
    checkRoute() {
      this.isDataBasePage = this.$route.path === "/dataBase/index";
      this.isSmartAnswerPage = this.$route.path === "/dataBase/smartAnswer"; // 新增判断
    },
    toLink(url) {
      window.open(url);
    },
    // iframe弹窗
    iframeBtn() {
      if (
        this.startXwidth.sWidth == this.boxRight ||
        this.startXwidth.sHeight == this.boxTop
      ) {
        this.ifrDialogVisible = !this.ifrDialogVisible;
      }
    },
    // 后保老师
    boxDragStart(e) {
      this.boxIsDragging = true;

      // 记录
      this.startXwidth.sWidth = this.boxRight;
      this.startXwidth.sHeight = this.boxTop;
      // 记录鼠标初始位置
      this.startX = e.clientX;
      this.startY = e.clientY;

      // 关键修复：用 right 表示水平位置，偏移量要重新计算
      // 视口宽度 - 元素 right 值 = 元素 left 值，以此计算偏移量
      const elementLeft = window.innerWidth - this.boxRight;
      this.boxOffsetX = e.clientX - elementLeft; // 鼠标相对于元素左边缘的偏移
      this.boxOffsetY = e.clientY - this.boxTop; // 垂直方向 top 逻辑不变

      // 给 document 添加拖拽中和结束事件（避免鼠标移出元素后停止拖拽）
      document.addEventListener("mousemove", this.boxDragging);
      document.addEventListener("mouseup", this.boxEndDrag);
    },
    // 拖拽中
    boxDragging(e) {
      if (!this.boxIsDragging) return;

      // 计算新的 right（视口宽度 - 鼠标位置 + 偏移量）
      let newRight = window.innerWidth - (e.clientX - this.boxOffsetX);
      let newTop = e.clientY - this.boxOffsetY;

      // 边界处理（避免拖出可视区域）
      const elementWidth = 10; // iframeBox 宽度，根据实际调整
      const elementHeight = 50; // iframeBox 高度，根据实际调整
      const minRight = 0; // 最小 right 值（贴右边界）
      const minTop = 0; // 最小 top 值（贴顶部）
      const maxRight = window.innerWidth - elementWidth; // 最大 right 值（贴左边界）
      const maxTop = window.innerHeight - elementHeight; // 最大 top 值（贴底部）

      // 限制 right 和 top 的范围
      this.boxRight = Math.max(minRight, Math.min(newRight, maxRight));
      this.boxTop = Math.max(minTop, Math.min(newTop, maxTop));
    },
    // 结束拖拽
    boxEndDrag() {
      this.boxIsDragging = false;
      // 移除 document 上的事件监听，避免内存泄漏
      document.removeEventListener("mousemove", this.boxDragging);
      document.removeEventListener("mouseup", this.boxEndDrag);
    },
    //  iframe开始拖拽
    dragStart(e) {
      this.isDragging = true;
      // 记录鼠标初始位置
      this.startX = e.clientX;
      this.startY = e.clientY;

      // 关键修复：用 right 表示水平位置，偏移量要重新计算
      // 视口宽度 - 元素 right 值 = 元素 left 值，以此计算偏移量
      const elementLeft = window.innerWidth - this.right;
      this.offsetX = e.clientX - elementLeft; // 鼠标相对于元素左边缘的偏移
      this.offsetY = e.clientY - this.top; // 垂直方向 top 逻辑不变

      // 给 document 添加拖拽中和结束事件（避免鼠标移出元素后停止拖拽）
      document.addEventListener("mousemove", this.dragging);
      document.addEventListener("mouseup", this.endDrag);
    },
    // 拖拽中
    dragging(e) {
      if (!this.isDragging) return;

      // 计算新的 right（视口宽度 - 鼠标位置 + 偏移量）
      let newRight = window.innerWidth - (e.clientX - this.offsetX);
      let newTop = e.clientY - this.offsetY;

      // 边界处理（避免拖出可视区域）
      const elementWidth = 10; // iframeBox 宽度，根据实际调整
      const elementHeight = 50; // iframeBox 高度，根据实际调整
      const minRight = 0; // 最小 right 值（贴右边界）
      const minTop = 0; // 最小 top 值（贴顶部）
      const maxRight = window.innerWidth - elementWidth; // 最大 right 值（贴左边界）
      const maxTop = window.innerHeight - elementHeight; // 最大 top 值（贴底部）

      // 限制 right 和 top 的范围
      this.right = Math.max(minRight, Math.min(newRight, maxRight));
      this.top = Math.max(minTop, Math.min(newTop, maxTop));
    },
    // 结束拖拽
    endDrag() {
      this.isDragging = false;
      // 移除 document 上的事件监听，避免内存泄漏
      document.removeEventListener("mousemove", this.dragging);
      document.removeEventListener("mouseup", this.endDrag);
    },
  },
};
</script>

<style lang="less" scoped>


.layoutContainer {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;

  &-header {
    display: flex;
    justify-content: space-between;

    &-left {
      display: flex;
      align-items: center;
      line-height: 60px;

      h6 {
        margin-left: 8px;
        font-size: 18px;
        line-height: 60px;
      }
    }

    &-right {
      &-span {
        color: red;
        font-size: 14px;
        margin-right: 10px;
        cursor: pointer;
      }

      &-consumer {
        color: green;
        font-size: 14px;
        margin-right: 10px;
        cursor: pointer;
      }

      // 「体验新EAS」入口（移植自 web-recruit-admin 的 .try-new-crm）
      // 那边头部是深色 #242f42，用白字 + 半透明白底；本项目头部是白底，
      // 所以配色换成红色系，结构 / 尺寸 / 闪烁动画保持一致。
      .try-new-crm {
        display: inline-block;
        vertical-align: middle;
        margin-right: 14px;
        padding: 3px 10px;
        font-size: 13px;
        line-height: 18px;
        white-space: nowrap;
        border-radius: 10px;
        // 本项目 base.css 没有全局 a 重置（recruit 的 index.scss 里有），
        // 不写这条会被浏览器默认下划线盖住
        text-decoration: none;
        color: #f56c6c;
        background: rgba(245, 108, 108, 0.08);
        border: 1px solid rgba(245, 108, 108, 0.35);
        transition: background-color 0.2s;
        animation: app-header-crm-blink 1.8s ease-in-out infinite;

        &:hover {
          color: #f56c6c;
          background: rgba(245, 108, 108, 0.2);
          animation: none;
        }
      }

      @keyframes app-header-crm-blink {
        0%,
        100% {
          background: rgba(245, 108, 108, 0.08);
          border-color: rgba(245, 108, 108, 0.35);
          box-shadow: 0 0 0 0 rgba(245, 108, 108, 0);
          transform: scale(1);
        }
        50% {
          color: #fff;
          background: rgba(245, 108, 108, 0.55);
          border-color: rgba(245, 108, 108, 0.8);
          box-shadow: 0 0 9px 0 rgba(245, 108, 108, 0.4);
          transform: scale(1.02);
        }
      }

      // 系统开了「减少动效」就不闪
      @media (prefers-reduced-motion: reduce) {
        .try-new-crm {
          animation: none;
        }
      }
    }
  }
}

.elAside {
  width: 64px !important;
}

.el-aside {
  text-align: left;
  color: #333;
  line-height: 200px;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
}

.el-header,
.el-footer {
  background-color: #ffffff;
  color: #333;
  text-align: center;
  line-height: 60px;
}

.el-menu-vertical-demo {
  height: 100%;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
}

.el-main {
  padding: 0;
  background-color: #f0f0f0;
}

.breadCrumb {
  margin-bottom: 20px;
}

// 真题库管理页面的 el-card 背景色
.data-base-card {
  background-color: #f0f0f0;
}

.smart-answer-card {
  /deep/.el-card__body {
    padding: 0 !important;
  }
}

// icon
.iconbox {
  position: fixed;
  right: 30px;
  top: 7%;
  cursor: pointer;
  width: 130px;
  height: 40px;
  background: white;
  border-radius: 25px;
  // width: 40px;
  // height: 130px;
  display: flex;
  // flex-direction: column;
  align-items: center;
  // justify-content: center;
  box-sizing: border-box;
  padding: 3px 0px;

  // border: 1px solid #f0f0f0;
  box-shadow: 0 0 10px rgba(113, 113, 113, 0.5);
  z-index: 9999;
  // padding-bottom: 5px;
  .avatar {
    width: auto;
    height: 40px;
    margin-left: 10px;
    margin-top: 2px;
  }

  p {
    margin-left: 5px;
    font-size: 14px;
  }
}
// ai
.iframeBox {
  position: fixed;
  // 阴影 上  右左
  box-shadow: 0 0 10px rgba(113, 113, 113, 0.5);
  overflow-x: auto;
  background-color: #f6f9fd;
  background-image: url(https://img.alicdn.com/imgextra/i2/O1CN01WQUzgB279O7Kw5YxN_!!6000000007754-2-tps-1182-790.png);
  background-repeat: no-repeat;
  background-size: 590px auto;
  background-position: 100% 0;
  width: 400px;
  border-radius: 5px;

  .iframe_header {
    width: 100%;
    height: 50px;
    background: linear-gradient(to right, #2e6ae1, #6b73c9, #9b7ab7, #d9839f);
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    cursor: move;
    user-select: none;
    border-bottom: 1px solid #cad8f3;
    z-index: 9999;
    .color_header {
      width: 100%;
      height: 5px;
    }
    .iframe_title {
      width: 100%;
      height: 45px;
      box-sizing: border-box;
      background-color: #fafbfd;

      padding: 0 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .iframe_body {
    width: 100%;
  }
  #vue_iframe {
    width: 100%;
    height: 600px;
    border: none;
    overflow-x: auto;
  }
}
</style>
